import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import { getUser } from '@/utils/auth'
import { getToken, isTokenExpired } from '@/utils/request'
import { buildAgentChildRoutes } from '@/views/digital-employee/agentRegistry'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/workflow-store',
    name: 'WorkflowStore',
    component: () => import('@/views/WorkflowStorePage.vue'),
  },
  {
    path: '/workflow-store/:id',
    name: 'WorkflowDetail',
    component: () => import('@/views/WorkflowDetailPage.vue'),
  },
  {
    path: '/agents-center',
    name: 'AgentsCenter',
    component: () => import('@/views/AgentsCenterPage.vue'),
  },
  {
    path: '/digital-employee',
    name: 'DigitalEmployee',
    component: () => import('@/views/digital-employee/DigitalEmployeePage.vue'),
  },
  {
    path: '/digital-employee/use/:empId',
    component: () => import('@/views/digital-employee/hub/DigitalEmployeeHubLayout.vue'),
    redirect: (to) => ({
      name: 'DeAgentEcom',
      params: { empId: to.params.empId || '2' },
    }),
    children: buildAgentChildRoutes(),
  },
  {
    path: '/digital-employee/ecom-workflow/:empId',
    name: 'EcomWorkflow',
    component: () => import('@/views/digital-employee/workflows/EcomWorkflowPage.vue'),
  },
  {
    path: '/digital-employee/general-workflow/:empId',
    name: 'GeneralWorkflow',
    component: () => import('@/views/digital-employee/workflows/GeneralWorkflowPage.vue'),
  },
  {
    path: '/digital-employee/video-workflow/:empId',
    name: 'VideoWorkflow',
    component: () => import('@/views/digital-employee/workflows/VideoWorkflowPage.vue'),
  },
  {
    path: '/agents-center/use/:agentId',
    name: 'AgentUsage',
    component: () => import('@/views/AgentUsagePage.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginPage.vue'),
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('@/views/CasesPage.vue'),
  },
  {
    path: '/cases/:id',
    name: 'CaseDetail',
    component: () => import('@/views/CaseDetailPage.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutPage.vue'),
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('@/views/PricingPage.vue'),
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import('@/views/UserCenterPage.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === 'UserCenter') {
    const token = getToken()
    if (!token || isTokenExpired()) {
      next({ name: 'Login', query: { redirect: to.fullPath, expired: token ? '1' : undefined } })
    } else if (!getUser()) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
